import { useEffect } from "react";
import { create } from "zustand";

type UnsavedChangesState = {
  dirtyCount: number;
  add: () => void;
  remove: () => void;
};

/** How many screens currently hold input the user has not saved. A count, so two forms can overlap. */
export const useUnsavedChangesStore = create<UnsavedChangesState>((set) => ({
  dirtyCount: 0,
  add: () => set((s) => ({ dirtyCount: s.dirtyCount + 1 })),
  remove: () => set((s) => ({ dirtyCount: Math.max(0, s.dirtyCount - 1) })),
}));

export const hasUnsavedChanges = (): boolean => useUnsavedChangesStore.getState().dirtyCount > 0;

/**
 * Call from a form with its `isDirty`. While true, the resume reload stays out of the way — it is
 * the one reload that can land mid-screen. The navigation reload needs no hold: that screen is gone.
 */
export function useHoldUpdateWhileDirty(isDirty: boolean): void {
  useEffect(() => {
    if (!isDirty) return;
    const { add, remove } = useUnsavedChangesStore.getState();
    add();
    return remove;
  }, [isDirty]);
}
